<template>
  <v-container class="flex-column">
    <div class="tab-section-name">
      Расчетные счета
    </div>
    <div
      class="d-flex padding"
      style="overflow:auto;max-width: calc(100vw - 384px);"
    >
      <modal-bank-account
        :dialog="dialog"
        :form="companyBankAccount"
        @showModal="showModal()"
        @closeModal="closeModal()"
        @submit="submit"
      />

      <v-progress-circular
        v-if="isLoading"
        size="40"
        indeterminate
      />
      <v-col
        v-if="hasCompanyBankAccounts"
        class="col-sm-12 d-flex mt-3 flex-wrap companies-wrapper"
      >
        <div class="tables-block">
          <v-col
            cols="12"
            sm="12"
            class="pt-0 pb-2 pl-mid-0 block-company"
          >
            <v-card class="v-card-table">
              <v-card-text class="pa-0">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="bill-name">
                          Название счета
                        </th>
                        <th class="currency">
                          Название банка
                        </th>
                        <th class="receipt">
                          Номер счета
                        </th>
                        <th class="available-balance">
                          Овердрафт
                        </th>
                        <th class="available-balance">
                          Валюта
                        </th>
                        <th class="available-balance">
                          Видимый?
                        </th>
                        <th class="available-balance">
                          Действия
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(companyBankAccount, index) in companyBankAccounts"
                        :key="index"
                      >
                        <td class="bill">
                          {{ companyBankAccount.name }}
                        </td>
                        <td class="bill-name">
                          {{ companyBankAccount.bank_name }}
                        </td>
                        <td class="email">
                          {{ companyBankAccount.account_number }}
                        </td>
                        <td class="email">
                          {{ companyBankAccount.overdraft }}
                        </td>
                        <td class="email">
                          {{ companyBankAccount.currency }}
                        </td>
                        <td class="email">
                          <v-checkbox v-model="companyBankAccount.is_visible"></v-checkbox>
                        </td>
                        <td class="email">
                          <v-icon
                            small
                            @click="editCompanyBankAccount(companyBankAccount)"
                          >
                            edit
                          </v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </div>
      </v-col>
    </div>
  </v-container>
</template>

<script>
  import ModalBankAccount from '../ModalBankAccount'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CompanyAccounts',
    components: { ModalBankAccount },

    props: {
      data: {
        type: Object,
      },
    },

    data () {
      return {
        dialog: false,
      }
    },

    computed: {
      ...mapGetters('companyBankAccount', [
        'companyBankAccount',
        'isSendFrom',
        'hasCompanyBankAccounts',
        'companyBankAccounts',
        'isLoading',
        'changeEditedBankAccountState',
      ]),
    },

    created () {
      this.$store.dispatch('companyBankAccount/fetchAllBankAccount', Object.assign({}, this.data))
    },

    methods: {
      showModal () {
        this.dialog = true
      },

      closeModal () {
        this.dialog = false
      },

      submit: function (formData) {
        formData.company = this.data
        formData.id === 0
          ? this.$store.dispatch('companyBankAccount/createBankAccount', formData)
          : this.$store.dispatch('companyBankAccount/updateBankAccount', formData)
      },

      editCompanyBankAccount ({ id }) {
        if (!this.hasCompanyBankAccounts) {
          return
        }

        const searchCompanyBankAccount = this.companyBankAccounts.find(i => i.id === id)
        const editedCompanyBankAccount = searchCompanyBankAccount === undefined ? companyBankAccount : searchCompanyBankAccount

        this.$store.commit('companyBankAccount/changeEditedBankAccountState', editedCompanyBankAccount)
        this.showModal()
      },
    },
  }
</script>

<style scoped lang="scss">
  .label {
    font-weight: bold;
    text-align: left;
  }

  .padding {
    padding: 20px;
  }

  .tab-section-name {
    width: 100%;
    color: #000;
    max-width: 250px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    white-space: normal;
    font-size: 20px;
    font-weight: 400;
    justify-content: flex-start;
    padding: 16px 16px 16px 50px;
  }
</style>
